import React from 'react'
import Events from '../components/Events/v4/Events'

export default function EventsV1(props) {
  const {
    // businessData,
    // configData,
    // options,
    gonationID,
    variantName
    // locationIndex,
    // isMultiLocationSite,
  } = props
  const variant = variantName ? variantName : 'eventsV4'

  return <Events {...props} gonationID={gonationID} variantName={variant} />
}
